import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { mapRetailModeSettingsToEditing } from "@store/Store/Data/RetailModeSettings/RetailModeSettingsSelector";
import { RetailModeSettingsState } from "@store/Store/Data/RetailModeSettings/RetailModeSettingsState";
import { RetailModeSettingsEditingModel, RetailModeSettingsModel } from "@store/Types/RetailModeSettings";
import { Draft } from "immer";

const initialState: RetailModeSettingsState = {};

const reducer = {
    "Store/Data/RetailModeSettings/UpdateRetailModeSettings": (
        draft: Draft<RetailModeSettingsState>,
        action: { settings: Partial<RetailModeSettingsEditingModel> },
    ) => {
        if (!draft.editingRetailMode) {
            throw new Error("There was no editingRetailMode set and we are trying to update it.");
        }

        if (typeof action.settings.priceIncreasePercent !== "undefined") {
            draft.editingRetailMode.priceIncreasePercent = action.settings.priceIncreasePercent?.toString();
        }

        if (typeof action.settings.activated !== "undefined") {
            draft.editingRetailMode.activated = action.settings.activated;
        }

        if (typeof action.settings.tierPricingActivated !== "undefined") {
            draft.editingRetailMode.tierPricingActivated = action.settings.tierPricingActivated;
        }

        if (typeof action.settings.pricingTiers !== "undefined") {
            draft.editingRetailMode.pricingTiers = action.settings.pricingTiers;
        }

        if (typeof action.settings.priceIncreaseType !== "undefined") {
            draft.editingRetailMode.priceIncreaseType = action.settings.priceIncreaseType;
        }
    },
    "Store/Data/RetailModeSettings/BeginLoadSettings": (draft: Draft<RetailModeSettingsState>) => {
        draft.isLoading = true;
    },
    "Store/Data/RetailModeSettings/BeginUpdateSettings": (draft: Draft<RetailModeSettingsState>) => {
        draft.isLoading = true;
    },
    "Store/Data/RetailModeSettings/ClearState": (draft: Draft<RetailModeSettingsState>) => {
        draft.retailModeSettings = initialState.retailModeSettings;
    },
    "Store/Data/RetailModeSettings/CompleteLoadSettings": (
        draft: Draft<RetailModeSettingsState>,
        action: { settings: RetailModeSettingsModel },
    ) => {
        if (action.settings !== undefined) {
            draft.retailModeSettings = action.settings;
            draft.editingRetailMode = mapRetailModeSettingsToEditing(action.settings);
        }
        draft.isLoading = false;
    },
};

const retailModeSettingsReducer = createTypedReducerWithImmer(initialState, reducer);
export default retailModeSettingsReducer;
